<template>
	<div class="right_body">
    <!-- 搜索 -->
    <!-- <search-box :fromData="fromData" @subSearch="subSearch"></search-box> -->
    <list-btn
    :listArr="listArr"
    @add="add"
    @edit="edit"
    @freeze="freeze"
    @unFreeze="unFreeze"
    @detail="detail"
    isAdd
    isEdit
    isFreeze
    ></list-btn>

<!-- 展开所有行 -->
<!-- default-expand-all -->
   <el-table
      :data="listArr"
      style="width: 100%;margin-bottom: 20px;"
      row-key="companyId"
      border
      highlight-current-row
      @current-change="handleCurrentChange"
      :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
      <el-table-column
        type="index"
        label="序号"
        width="50">
      </el-table-column>
      <el-table-column
        v-for="(item,index) in tabColumns"
        :prop="item.field"
        :label="item.title"
        :formatter="item.formatter"
        :width="item.width">
      </el-table-column>
    </el-table>

    <!-- 新增 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" v-dialogDrag>
      <el-form :model="companyFrom" :rules="rules" ref="companyFrom" label-width="90px">
        <el-form-item label="类型" prop="type">
          <el-select v-model="typeTxt" @change="changeType" placeholder="请选择" :disabled="isType">
            <el-option label="集团" value="1"></el-option>
            <el-option label="公司" value="2"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="所属公司" prop="type">
          <el-select v-model="parentCompanyTxt" @change="changeCompany" placeholder="请选择">
            <el-option label="顶级" value="0"></el-option>
            <el-option :label="item.value"  :value="item.companyId" v-for="(item,index) in listArr"></el-option>
          </el-select>
        </el-form-item>

       <!-- <el-form-item label="所属公司" v-if="parentCompanyTxt != ''">
          <el-input v-model="parentCompanyTxt" autocomplete="off"></el-input>
        </el-form-item> -->

        <el-form-item label="公司编码"  prop="companyCode">
          <el-input v-model="companyFrom.companyCode" autocomplete="off" :disabled="companyFrom.companyId ? true : false" maxlength="4"
  show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="公司名称" prop="companyName">
          <el-input v-model="companyFrom.companyName" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="状态11" prop="type">
          <el-select v-model="statusTxt" @change="changeStatus" placeholder="请选择">
            <el-option label="启用" value="1"></el-option>
            <el-option label="冻结" value="0"></el-option>
          </el-select>
        </el-form-item>

      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click.stop="submitForm" v-loading="$store.state.isLoading" :isDisable="isDisable">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 查看 -->
    <el-dialog title="查看" :visible.sync="detailDialog" v-dialogDrag>
      <table class="tab_detail tab_custom">
        <tr><th width="130">类型</th><td>{{typeTxt}}</td></tr>
        <tr><th>所属公司</th><td>{{parentCompanyTxt}}</td></tr>
        <tr><th>公司编码</th><td>{{companyFrom.companyCode}}</td></tr>
        <tr><th>公司名称</th><td>{{companyFrom.companyName}}</td></tr>
        <tr><th>状态</th><td>{{statusTxt}}</td></tr>
      </table>
    </el-dialog>


	</div>
</template>

<script>
import {company} from 'api/system.js';
import listBtn from 'components/btn/listBtn.vue';
import tabList  from 'components/table/list.vue';
import searchBox from './components/search.vue';
export default {
	components:{
    tabList,
    listBtn,
    searchBox
	},
    data() {
      return {
        activeName: 'base',
        isType:true,
        isDisable:false,
        dialogFormVisible:false,
        detailDialog:false,
        companyFrom:{
          type:2,
          status:1,
          parentCompanyId:0
        },//公司提交信息
        sdata:{},
        slist:[],//未变成树型数组
        listArr:[],
        isEdit:false,//状态
        isDetail:false,//查看详情状态
        dialogTitle:"新增",
        typeTxt:"集团",
        statusTxt:"启用",
        parentCompanyTxt:"",
        parentCompanyId:0,
        rules:{
          type: [{
            required: true,
            message: '请选择类型',
            trigger: 'change',
          }],
          companyCode:[{
            required: true,
            message: "请输入公司编码",
            trigger: "blur" ,
          },{
            pattern:/^[a-zA-Z0-9]+$/,
            message: "编码格式错误，只能输入数字或英文字母",
            trigger: "blur" ,
          }],
          companyName:[{
            required: true,
            pattern:/^[a-zA-Z0-9_\u4E00-\u9FA5]+$/,
            message: "请输入公司名称",
            trigger: "blur" ,
          }]
        },
        tabColumns:[
          {field: 'companyCode', title: '公司编码', width:100,"sortable":true},
          {field: 'companyName', title: '公司名称'},
          {field: 'type', title: '类型',
          formatter(row){
            return row.type == 1 ? "集团" : "公司";
          }},
          {field: 'status', title: '状态', width: 80,
          formatter(row,rowIndex,pagingIndex,field) { 
            return row.status == 1 ? "启用" : "冻结";
          }}
        ],//表头字段
        total:0,//总条数
        pages:0,//总页数
        fromData:{
        	page:1,//当前页
        	pageSize:1000,//每页显示的数量,
        	searchCriteria:{//查询的附加条件
        	}
        }
      };
    },
    created(){
      this.getListArr();
    },
    mounted() {
      //this.restaurants = this.listArr;
    },
    //监测变化
    watch:{

    },
    methods: {
      //递归成树状
      filterArray(data, parent,level = 0){
        level++;
        var tree = [];
        var temp;
        for (var i = 0; i < data.length; i++) {
          if (data[i].parentCompanyId == parent) {
            let levelStr = "";
            for(var j=1;j<level;j++){
              levelStr = levelStr + '|- ';
            }
            data[i].level = level;
            data[i].value = levelStr + data[i].companyCode + ' - ' + data[i].companyName;
            var obj = data[i];
            temp = this.filterArray(data, data[i].companyId,level);
            if (temp.length > 0) {
              obj.children = temp;
            }
            tree.push(obj);
          }
        }
        return tree;
      },
       //搜索
      subSearch(){
        this.getListArr();
        //console.log(1111);
      },

      //新增
      add(){
        this.dialogTitle = "新增";
        this.isEdit = false;
        this.companyFrom = {
          type:2,
          status:1
        };
        if(this.listArr.length){
          this.isType = true;
        }else{
          this.isType = false;
        }
        this.dialogFormVisible = true;
        this.detailDialog = false;
        this.isDetail = false;
      },
      edit(){
        this.dialogTitle = "编辑";
        this.isEdit = true;
        if(!this.sdata.companyId){
          this.$message.error('请选择需要编辑的数据');
          return;
        }
        this.companyFrom = JSON.parse(JSON.stringify(this.sdata));;
        this.dialogFormVisible = true;
        this.detailDialog = false;
        this.isDetail = false;
        let obj = this.slist.find(v => v.companyId === this.sdata.parentCompanyId);
        if(obj){
          this.parentCompanyTxt = obj.companyCode +' - '+obj.companyName;
          this.parentCompanyId = obj.companyId;
          //this.parentCompanyId = obj.
        }else{
          this.parentCompanyTxt = "顶级";
          this.parentCompanyId = 0;
        }
      },
      detail(){
        if(!this.sdata.companyId){
          this.$message.error('请选择需要查看的记录');
          return;
        }
        this.dialogTitle = "查看";
        this.dialogFormVisible = false;
        this.detailDialog = true;
        this.isDetail = true;
        this.companyFrom = JSON.parse(JSON.stringify(this.sdata));
        let obj = this.slist.find(v => v.companyId === this.sdata.parentCompanyId);
        if(obj){
          this.parentCompanyTxt = obj.companyCode +' - '+obj.companyName;
          this.parentCompanyId = obj.companyId;
          //this.parentCompanyId = obj.
        }else{
          this.parentCompanyTxt = "顶级";
          this.parentCompanyId = 0;
        }
      },
      //冻结
      freeze(){

      },
      //解冻
      unFreeze(){

      },
      del(){
        if(!this.sdata.companyId){
          this.$message.error('请选择需要操作的数据');
          return;
        }
        this.$confirm('确定删除这条记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          this.$loading.show('处理中...');
          let res = await this.$post(company.del,{companyId:this.sdata.companyId});
          this.$loading.hide();
          if(res.status){
            this.$message.success(res.msg);
            this.getListArr();
          }else{
            this.$message.error(res.errorMsg);
          }
        }).catch(() => {
        });
      },

      //获取列表
      async getListArr(){
        //console.log(JSON.stringify(this.fromData,'=== 55555 =='));
        let res = await this.$post(company.list,this.fromData);
        if(res.status && res.data.list){
          this.slist = res.data.list;
          this.listArr = this.filterArray(res.data.list,0);
          this.isType = true;
          this.typeTxt = "公司";
          this.companyFrom.type = 2;
        }else{
          this.isType = false;
          this.listArr = [];
        }
        //console.log(this.listArr,888);
      },
      //当前页码改变
      currentChange(currentPage){
        this.fromData.page = currentPage;
        this.getListArr();
      },

      //类型改变
      changeType(val){
        this.companyFrom.type = val;
      },
      //公司改变
      changeCompany(val){
        this.parentCompanyId = val;
      },
      //状态改变
      changeStatus(val){
        this.companyFrom.status = val;
        if(val == 1){
          this.statusTxt = "启用";
        }else{
          this.statusTxt = "冻结";
        }
      },
      //单击选中这条数据
      handleCurrentChange(val) {
        //console.log(val,666)
        this.sdata = val;
        this.parentCompanyTxt = val.companyCode +' - '+ val.companyName;
        this.parentCompanyId = val.companyId;
        console.log(this.sdata);
        if(this.sdata.status == 0){
          this.statusTxt = "冻结";
        }else{
          this.statusTxt = "启用";
        }
      },
      //提交
      submitForm(){
        let vm = this;
        this.$refs['companyFrom'].validate(async (vaild)=>{
          if(vaild){
            // alert(111);
            let postUrl = company.add;
            if(this.isEdit) postUrl = company.modify;
            this.isDisable = true;
            if(this.parentCompanyTxt){
              this.companyFrom.parentCompanyId = this.parentCompanyId;
            }
            let res = await this.$post(postUrl,this.companyFrom);
            console.log(res,'===111==');
            if(res.status){
              this.$message.success(res.msg);
              this.companyFrom = {
                type:2,
                status:1
              };
              this.dialogFormVisible = false;
              this.getListArr();
            }else{
              this.$message.error(res.errorMsg);
            }
          }else{
            return false;
          }
        });
      }

    }
  };
</script>

<style lang="stylus" scoped>

</style>
